<div class="dialog-content">
    <div mat-dialog-content>
        {{message}}
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button (click)="onCancelClick()"><b>{{'cancel' | translate}}</b></button>
        <button mat-raised-button class="confirmButton" [mat-dialog-close]="true" cdkFocusInitial><b>{{'yes' |
                translate}}</b></button>
    </div>
</div>